import { ActionType } from '../index';
import { SCHOOL_ACTION } from './actionTypes';
import { endPoints, Params } from '@/shared/types/api';
import { axios } from '@/plugins/axios';
import { SCHOOL_MUTATION } from '../mutations/mutationTypes';
import vueRouter from '@/router';
import { useNotification } from '@/shared/hooks/useNotification';

export const schoolActions = {
  [SCHOOL_ACTION.GET_SCHOOLS]: (
    { commit }: ActionType,
    payload: Params<'listSchools'>,
  ) => {
    axios
      .get(endPoints.listSchools.endPoint, { params: payload })
      .then((res) => {
        commit(SCHOOL_MUTATION.GET_SCHOOLS, res.data);
      });
  },
  [SCHOOL_ACTION.GET_ADMIN_SCHOOLS]: (
    { commit }: ActionType,
    payload: Params<'listAdminSchools'>,
  ) => {
    axios
      .get(endPoints.listAdminSchools.endPoint, { params: payload })
      .then((res) => {
        commit(SCHOOL_MUTATION.GET_ADMIN_SCHOOLS, res.data);
      });
  },
  [SCHOOL_ACTION.SAVE_PUBLISH_DATES]: (
    { commit }: ActionType,
    payload: Params<'savePublishDate'>,
  ) => {
    const { showNotification } = useNotification();

    axios.post(endPoints.savePublishDate.endPoint, payload).then((res) => {
      commit(SCHOOL_MUTATION.SAVE_PUBLISH_DATES, res.data);
      showNotification({
        isShow: true,
        message: '公開日を変更しました',
        type: 'success',
      });
      vueRouter.back();
    });
  },
  [SCHOOL_ACTION.GET_STATUSES]: (
    { commit }: ActionType,
    payload: Params<'listStatuses'>,
  ) => {
    axios
      .get(endPoints.listStatuses.endPoint, { params: payload })
      .then((res) => {
        commit(SCHOOL_MUTATION.GET_STATUSES, res.data);
      });
  },
  [SCHOOL_ACTION.TO_PRIVATE]: (
    { commit }: ActionType,
    payload: Params<'forcedPublishDisable'>,
  ) => {
    const { showNotification } = useNotification();

    axios.post(endPoints.forcedPublishDisable.endPoint, payload).then((res) => {
      commit(SCHOOL_MUTATION.TO_PRIVATE, res.data);
      showNotification({
        isShow: true,
        message: '公開を停止しました',
        type: 'success',
      });
      vueRouter.back();
    });
  },
  [SCHOOL_ACTION.RESET_PUBLISH]: (
    { commit }: ActionType,
    payload: Params<'resetPublish'>,
  ) => {
    const { showNotification } = useNotification();

    axios.post(endPoints.resetPublish.endPoint, payload).then((res) => {
      commit(SCHOOL_MUTATION.RESET_PUBLISH, res.data);
      showNotification({
        isShow: true,
        message: '公開情報をリセットしました',
        type: 'success',
      });
      vueRouter.back();
    });
  },
  [SCHOOL_ACTION.CHANGE_ENABLED]: (
    { commit }: ActionType,
    payload: Params<'changeEnabled'>,
  ) => {
    const { showNotification } = useNotification();

    axios.post(endPoints.changeEnabled.endPoint, payload).then(() => {
      commit(SCHOOL_MUTATION.CHANGE_ENABLED, payload);
      showNotification({
        isShow: true,
        message: '有効/無効を切り替えました',
        type: 'success',
      });
      vueRouter.back();
    });
  },
};
